var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMamViewerManual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 505,
    height: 134,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 284,
    width: 505,
    height: 134
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1266825,
    height: 1276350
  })), /*#__PURE__*/React.createElement("image", {
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,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",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1266825,
    height: 1266825
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-441 -284)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(0.000104987 0 0 0.000104987 442 284)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    transform: "scale(1 1.00752)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "scale(12668.2 12668.2)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M595 306 595 396.408",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 53,
    transform: "translate(606.726 369)"
  }, "MAM"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 53,
    transform: "translate(740.893 369)"
  }, "VIEWE"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 53,
    transform: "translate(884.226 369)"
  }, "R"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMamViewerManual);
export default __webpack_public_path__ + "static/media/mamViewerManual.0fbd12d6fd387e6c566a33b6d1238512.svg";
export { ForwardRef as ReactComponent };